export enum ShipmentSubType {
    Regular = 0,
    Return = 1,
}
